module.exports = __webpack_public_path__ + "assets/7efda2af3ec027a22b96eaa2c53a9e9a.png";